import { ZPromoConditions } from '@daymade/common-lib/dbJsonModels';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZPromoCodeSelect } from './models';

const c = initContract();
export const publicPromoContract = c.router(
  {
    getPromo: {
      method: 'POST',
      path: '/order',
      body: z.object({
        referralId: z.optional(z.string()).nullable(),
        promoCode: z.optional(z.string()).nullable(),
        evalData: z.optional(ZPromoConditions.partial()),
      }),
      responses: {
        200: z.object({
          promoCode: z.optional(ZPromoCodeSelect),
          message: z.optional(z.string()).nullable(),
          referralDetails: z
            .optional(
              z.object({
                firstName: z.string(),
                avatarLocation: z.string().optional().nullable(),
              }),
            )
            .nullable(),
        }),
        400: c.type<{ message: string }>(),
      },
    },
    getIntroOffer: {
      method: 'GET',
      path: '/entry-offer',
      query: z.object({
        playerId: z.optional(z.string()).nullable(),
        testGroup: z.optional(z.string()).nullable(),
      }),
      responses: {
        200: z.object({
          promoCode: z.optional(ZPromoCodeSelect),
        }),
        400: c.type<{ message: string }>(),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/public',
    jsonQuery: true,
    strictStatusCodes: true,
  },
);
